// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QOdJB","content":"styles_content__A9UoR","tableWrap":"styles_tableWrap__2Qyba"};